var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsage5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.35,
    height: 27.526,
    viewBox: "0 0 30.35 27.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1.25 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M19.248,29.776H3.72a2.473,2.473,0,0,1-2.47-2.47V4.72A2.473,2.473,0,0,1,3.72,2.25H17.836a2.473,2.473,0,0,1,2.47,2.47v24a1.059,1.059,0,0,1-1.059,1.059ZM3.72,4.367a.353.353,0,0,0-.353.353V27.306a.353.353,0,0,0,.353.353H18.189V4.72a.353.353,0,0,0-.353-.353Z",
    fill: "#c03ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M22.778,28.542h-8.47a1.059,1.059,0,0,1-1.059-1.059V6.309a1.059,1.059,0,0,1,1.532-.947l10.512,5.257a2.456,2.456,0,0,1,1.366,2.209V24.66A3.885,3.885,0,0,1,22.778,28.542Zm-7.411-2.117h7.411a1.767,1.767,0,0,0,1.765-1.765V12.828a.35.35,0,0,0-.195-.315L15.367,8.021Z",
    transform: "translate(4.939 1.235)",
    fill: "#c03ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M12.867,24.425H5.809A1.059,1.059,0,0,1,4.75,23.367V17.015A1.767,1.767,0,0,1,6.515,15.25h5.646a1.767,1.767,0,0,1,1.765,1.765v6.352A1.059,1.059,0,0,1,12.867,24.425Zm-6-2.117h4.941V17.367H6.867Z",
    transform: "translate(1.441 5.351)",
    fill: "#c03ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M20.132,13.367H17.309a1.059,1.059,0,1,1,0-2.117h2.823a1.059,1.059,0,1,1,0,2.117Z",
    transform: "translate(6.174 3.704)",
    fill: "#c03ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M20.132,16.367H17.309a1.059,1.059,0,1,1,0-2.117h2.823a1.059,1.059,0,1,1,0,2.117Z",
    transform: "translate(6.174 4.939)",
    fill: "#c03ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M20.132,19.367H17.309a1.059,1.059,0,1,1,0-2.117h2.823a1.059,1.059,0,1,1,0,2.117Z",
    transform: "translate(6.174 6.174)",
    fill: "#c03ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M11.22,13.867H9.809a1.059,1.059,0,0,1,0-2.117H11.22a1.059,1.059,0,0,1,0,2.117Z",
    transform: "translate(3.087 3.91)",
    fill: "#c03ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M11.22,7.867H9.809a1.059,1.059,0,0,1,0-2.117H11.22a1.059,1.059,0,0,1,0,2.117Z",
    transform: "translate(3.087 1.441)",
    fill: "#c03ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M11.22,10.867H9.809a1.059,1.059,0,0,1,0-2.117H11.22a1.059,1.059,0,0,1,0,2.117Z",
    transform: "translate(3.087 2.675)",
    fill: "#c03ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M7.22,13.867H5.809a1.059,1.059,0,1,1,0-2.117H7.22a1.059,1.059,0,0,1,0,2.117Z",
    transform: "translate(1.441 3.91)",
    fill: "#c03ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M7.22,7.867H5.809a1.059,1.059,0,1,1,0-2.117H7.22a1.059,1.059,0,0,1,0,2.117Z",
    transform: "translate(1.441 1.441)",
    fill: "#c03ffb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M7.22,10.867H5.809a1.059,1.059,0,1,1,0-2.117H7.22a1.059,1.059,0,0,1,0,2.117Z",
    transform: "translate(1.441 2.675)",
    fill: "#c03ffb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsage5);
export default __webpack_public_path__ + "static/media/usage-5.6d15e45223d2fef7e0f1b6648f99d45c.svg";
export { ForwardRef as ReactComponent };